module.exports = __webpack_public_path__ + "static/two-b471313b88166cf01a26cce30d7436f1.png";